'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var t = require('react');
var DisableFeatureContext = require('../DisableFeatureContext.js');

var useDisableFeature = function useDisableFeature() {
  var result = t.useContext(DisableFeatureContext.DisableFeatureContext);
  return result;
};

exports.default = useDisableFeature;
exports.useDisableFeature = useDisableFeature;
//# sourceMappingURL=useDisableFeature.js.map
